import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[clickOutside]',
})
export class ClickOutsideDirective {
    private _elementRef = inject(ElementRef);

    @Output()
    public clickOutside = new EventEmitter();

    @HostListener('document:click', ['$event'])
    public onClick(event: MouseEvent) {
        const clickedInside = event.composedPath().includes(this._elementRef.nativeElement);
        if (!clickedInside) this.clickOutside.emit(null);
    }
}
